import { StockItemGroupStats } from "../../inventory/models/models";
import api from "../../../core/api";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerStockItemGroupsApi {
  getStockItemGroups(): Promise<StockItemGroupStats[]> {
    return api.get<StockItemGroupStats[]>(
      `/v1/groups`, { ...getRequestConfig(), paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }
}

export default new CustomerStockItemGroupsApi()
